<template>
    <div v-if="loaded">
        <v-row>
            <v-col cols="12" md="6">
                <ui-section :title="isLegal ? 'Solicitações do Jurídico' : 'Fiscalização mensal'"
                    :description="isLegal
                        ? 'Com o Jurídico ativo, a plataforma solicita os documentos no dia 1 após o fim de cada período, às 8h, e cobra até a entrega.'
                        : 'Com o RMA ativo, a plataforma solicita os documentos no dia 1 de cada mês, às 8h, e cobra até a entrega.'">
                    <v-switch v-model="form.active" inset hide-details class="mt-0 mb-2"
                        :label="isLegal ? (form.active ? 'Jurídico ativo neste caso' : 'Jurídico desativado') : (form.active ? 'RMA ativo neste caso' : 'RMA desativado')"></v-switch>
                    <v-checkbox v-if="!isLegal" v-model="form.rural_producer" dense hide-details class="mt-0 mb-4" label="Caso de produtor rural (usa o questionário modelo na aba Questionário)"></v-checkbox>
                    <v-row dense class="mb-1">
                        <v-col cols="12" sm="6">
                            <v-select v-model="form.period_months" :items="periodOptions" item-value="value" item-text="text" label="Periodicidade" outlined dense hide-details="auto"
                                :menu-props="{ offsetY: true }"></v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select v-model="form.start_competence" :items="startItems" :label="form.period_months > 1 ? 'Primeiro mês do 1º período' : 'Competência inicial'" outlined dense hide-details="auto"
                                :menu-props="{ offsetY: true }"></v-select>
                        </v-col>
                    </v-row>
                    <p class="ui-small ui-muted mb-4">{{ startHint }}</p>
                    <v-row dense>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model.number="form.due_day" type="number" min="1" max="31" :label="form.period_months > 1 ? 'Prazo (dia do mês após o período)' : 'Prazo (dia do mês seguinte)'" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model.number="form.reminder_days_before" type="number" min="0" max="15" label="Lembrete (dias antes)" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="4">
                            <v-text-field v-model.number="form.overdue_interval_days" type="number" min="0" max="30" label="Cobrar a cada (dias)" outlined dense hide-details="auto"></v-text-field>
                        </v-col>
                    </v-row>
                    <p class="ui-small ui-muted mt-2 mb-0">
                        Exemplo com estes valores: {{ exampleLabel }}, solicitação em {{ exampleRequest }}, lembrete em {{ exampleReminder }}, prazo em {{ exampleDue }}
                        e, se faltar algo, registro de prazo perdido no dia seguinte e nova cobrança {{ form.overdue_interval_days ? `a cada ${form.overdue_interval_days} dias` : "uma vez só" }}.
                    </p>
                </ui-section>

                <ui-section class="mt-5" title="Empresas do grupo" description="Cada empresa recebe o próprio checklist. O cadastro das empresas fica na tela do caso.">
                    <template #actions>
                        <v-btn small text color="primary" :to="`/casos/${clientId}`"><v-icon left small>mdi-open-in-new</v-icon>Editar no caso</v-btn>
                    </template>
                    <div v-if="!companies.length" class="ui-small ui-muted">
                        O caso não tem empresas cadastradas. Ao ativar, a plataforma cria uma com o nome e o CNPJ do caso.
                    </div>
                    <v-checkbox v-for="company in companies" :key="company.id" v-model="form.company_ids" :value="company.id" dense hide-details class="mt-0 mb-1">
                        <template #label>
                            <span>{{ company.name }}<span v-if="company.registration" class="ui-muted"> · {{ company.registration }}</span></span>
                        </template>
                    </v-checkbox>
                </ui-section>

                <ui-section class="mt-5" :title="isLegal ? 'Responsável pelo Jurídico (BeJ)' : 'Responsável pelo RMA'" description="Recebe por e-mail, no dia seguinte, o resumo dos documentos que a devedora enviou.">
                    <v-autocomplete v-model="form.responsible_admin_id" :items="admins" item-value="id" :item-text="adminText" label="Responsável" placeholder="Sem responsável"
                        outlined dense clearable hide-details :menu-props="{ offsetY: true }">
                        <template #item="{ item }">
                            <div class="py-1">
                                <div class="ui-cell-main">{{ item.name }}</div>
                                <div class="ui-cell-sub">{{ item.email }}</div>
                            </div>
                        </template>
                    </v-autocomplete>
                    <p v-if="responsibleHint" class="ui-small mt-2 mb-0" :style="{ color: responsibleHint.tone === 'warn' ? '#b45309' : '#2b2050' }">{{ responsibleHint.text }}</p>
                    <p class="ui-small ui-muted mt-2 mb-0">
                        {{ form.responsible_admin_id ? "O resumo sai a partir das 8h e só quando houver envio no dia anterior." : "Sem responsável, o resumo diário não é enviado." }}
                    </p>
                    <v-switch v-model="form.review_before_send" inset hide-details class="mt-4 mb-1" label="Revisar os e-mails automáticos antes do envio"></v-switch>
                    <p class="ui-small ui-muted mb-0">
                        {{ form.review_before_send
                            ? "A solicitação, o lembrete e as cobranças não saem sozinhos: a plataforma prepara o e-mail, avisa o responsável e ele revisa, edita e envia pelo Histórico da competência."
                            : "Desligado, os e-mails da régua saem automaticamente. Os envios manuais sempre abrem o editor para revisão." }}
                    </p>
                </ui-section>

                <ui-section class="mt-5" title="Abrir competência agora" description="Para começar o piloto, registrar meses anteriores ou colocar o caso em dia. O checklist é criado na hora.">
                    <div ref="openSection">
                        <v-select v-model="open.competences" :items="openItems" label="Competências" multiple chips small-chips deletable-chips outlined dense hide-details
                            :menu-props="{ offsetY: true }" class="mb-2"></v-select>
                        <div class="d-flex flex-wrap align-center" style="gap: 12px;">
                            <v-checkbox v-model="open.sendRequest" dense hide-details class="mt-0" label="Enviar a solicitação por e-mail agora"></v-checkbox>
                            <v-spacer></v-spacer>
                            <v-btn v-if="$allowed('rma.activate')" color="primary" depressed :disabled="!savedActive || !open.competences.length" :loading="open.saving" @click="openCompetence">
                                {{ open.competences.length > 1 ? `Abrir ${open.competences.length} competências` : "Abrir competência" }}
                            </v-btn>
                        </div>
                    </div>
                    <p v-if="!savedActive" class="ui-small ui-muted mt-2 mb-0">Ative e salve a configuração antes de abrir uma competência.</p>
                    <p v-else-if="!open.sendRequest" class="ui-small ui-muted mt-2 mb-0">Sem a solicitação, a competência fica sem cobrança automática até você enviar pelo Histórico.</p>
                    <p v-else-if="open.competences.length > 1" class="ui-small ui-muted mt-2 mb-0">
                        A recuperanda recebe um e-mail só, com os documentos e o prazo de cada competência. Cada competência segue com o próprio checklist e as próprias cobranças.
                    </p>
                </ui-section>
            </v-col>

            <v-col cols="12" md="6">
                <ui-section title="Documentos solicitados" :description="documentsDescription">
                    <template #actions>
                        <v-btn v-if="(form.documents_mode === 'default') && $allowed('rma.activate')" small text @click="toggleAllTypes">{{ form.type_ids.length === documentTypes.length ? "Desmarcar todos" : "Marcar todos" }}</v-btn>
                    </template>
                    <ui-pills v-model="form.documents_mode" :items="modeItems" class="mb-2" />
                    <p class="ui-small ui-muted mb-3">
                        {{ form.documents_mode === "default"
                            ? "Todas as empresas do grupo recebem a mesma lista. Cada CNPJ continua com o próprio checklist e os próprios arquivos."
                            : "Escolha os documentos de cada CNPJ. A mudança vale para as competências em aberto e as próximas." }}
                    </p>

                    <template v-if="form.documents_mode === 'default'">
                        <v-checkbox v-for="type in documentTypes" :key="type.id" v-model="form.type_ids" :value="type.id" dense hide-details class="mt-0 mb-1">
                            <template #label>
                                <span>{{ String(type.sort_order).padStart(2, "0") }} · {{ type.name }} <span class="ui-muted ui-small">({{ formatExtensions(type.accepted_extensions) }})</span></span>
                            </template>
                        </v-checkbox>
                    </template>

                    <template v-else>
                        <div v-if="!enabledCompanies.length" class="ui-suggestion ui-suggestion--warn">
                            Marque as empresas em "Empresas do grupo" para escolher os documentos de cada CNPJ.
                        </div>
                        <v-expansion-panels v-else v-model="openCompanyPanels" multiple flat class="rma-docs-companies">
                            <v-expansion-panel v-for="company in enabledCompanies" :key="company.id" class="rma-docs-company">
                                <v-expansion-panel-header class="rma-docs-company__header">
                                    <div style="min-width: 0;">
                                        <div class="ui-cell-main text-truncate">{{ company.name }}</div>
                                        <div class="ui-cell-sub">
                                            {{ company.registration ? `CNPJ ${company.registration} · ` : "" }}{{ (form.company_type_ids[company.id] || []).length }} de {{ documentTypes.length }} documentos
                                        </div>
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <div class="d-flex flex-wrap mb-1" style="gap: 4px;">
                                        <v-btn v-if="$allowed('rma.activate')" x-small text color="primary" @click="toggleCompanyTypes(company.id)">
                                            {{ (form.company_type_ids[company.id] || []).length === documentTypes.length ? "Desmarcar todos" : "Marcar todos" }}
                                        </v-btn>
                                        <v-btn x-small text color="primary" @click="copyDefaultTypes(company.id)">Usar a lista padrão</v-btn>
                                    </div>
                                    <v-checkbox v-for="type in documentTypes" :key="`${company.id}-${type.id}`" v-model="form.company_type_ids[company.id]" :value="type.id"
                                        dense hide-details class="mt-0 mb-1">
                                        <template #label>
                                            <span>{{ String(type.sort_order).padStart(2, "0") }} · {{ type.name }}</span>
                                        </template>
                                    </v-checkbox>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </template>
                </ui-section>

                <!-- Responsavel da devedora pela area (ex.: advogado): recebe as solicitacoes e cobrancas no lugar de todos. -->
                <ui-section class="mt-5" title="Responsável na recuperanda"
                    description="Usuário da devedora que atende estas solicitações. Com um responsável, solicitações e cobranças desta área vão só para ele (mais a cópia interna).">
                    <v-select v-model="form.client_admin_id" :items="clientResponsibleOptions" item-value="id" item-text="label" label="Responsável na recuperanda"
                        outlined dense clearable hide-details :menu-props="{ offsetY: true }" placeholder="Todos os representantes"></v-select>
                    <p class="ui-small ui-muted mt-2 mb-0">
                        {{ form.client_admin_id ? "Só o responsável recebe os e-mails desta área. Os demais representantes continuam vendo os documentos no painel." : "Sem responsável, todos os representantes ativos recebem os e-mails desta área." }}
                    </p>
                </ui-section>

                <ui-section class="mt-5" title="Representantes da recuperanda" description="Acessam o Painel da Devedora e recebem as solicitações e cobranças.">
                    <template #actions>
                        <v-btn small text color="primary" to="/usuarios-recuperanda"><v-icon left small>mdi-account-cog-outline</v-icon>Gerenciar</v-btn>
                    </template>
                    <ul v-if="representatives.length" class="ui-checks mb-4">
                        <li v-for="person in representatives" :key="person.id">
                            <v-icon small :color="person.active ? 'success' : undefined">mdi-account-outline</v-icon>
                            <div style="flex: 1; min-width: 0;">
                                <div class="ui-cell-main">{{ person.name }}</div>
                                <div class="ui-cell-sub">{{ person.email }}</div>
                                <div class="ui-cell-sub">{{ person.last_access_at ? `Último acesso em ${formatDateTime(person.last_access_at)}` : "Sem acesso registrado" }}</div>
                            </div>
                            <ui-badge :status="person.active ? 'active' : 'inactive'" />
                        </li>
                    </ul>
                    <div v-else class="ui-suggestion ui-suggestion--warn mb-4">Nenhum representante cadastrado: as cobranças não terão destinatário além do e-mail do cadastro do caso.</div>
                    <div class="ui-label">Convidar representante</div>
                    <v-row dense>
                        <v-col cols="12" sm="6"><v-text-field v-model="invite.name" label="Nome" outlined dense hide-details></v-text-field></v-col>
                        <v-col cols="12" sm="6"><v-text-field v-model="invite.email" label="E-mail" type="email" outlined dense hide-details></v-text-field></v-col>
                    </v-row>
                    <div class="d-flex align-center flex-wrap mt-2" style="gap: 8px;">
                        <p class="ui-small ui-muted mb-0" style="flex: 1; min-width: 200px;">O representante recebe por e-mail uma senha provisória de acesso ao Painel da Devedora.</p>
                        <v-btn v-if="$allowed('rma.activate')" outlined :disabled="!canInvite" :loading="invite.saving" @click="sendInvite"><v-icon left small>mdi-account-plus-outline</v-icon>Convidar</v-btn>
                    </div>
                </ui-section>

                <ui-section class="mt-5" title="Cópia interna" description="E-mails da equipe BeJ que recebem uma cópia de cada solicitação e cobrança (um por linha).">
                    <v-textarea v-model="form.cc_emails" outlined dense rows="3" auto-grow hide-details placeholder="advogado@brizolaejapur.com.br"></v-textarea>
                </ui-section>
            </v-col>
        </v-row>

        <div class="d-flex justify-end mt-5" style="gap: 8px;">
            <v-btn outlined :disabled="saving" @click="load">Descartar alterações</v-btn>
            <v-btn v-if="$allowed('rma.activate')" color="primary" depressed :loading="saving" @click="save">Salvar configuração</v-btn>
        </div>
    </div>
    <section v-else class="ui-card"><ui-empty icon="mdi-cog-outline" text="Carregando configuração..." /></section>
</template>

<script>
import axios from "axios";
import { competenceLabel, formatDate, formatDateTime, formatExtensions, notifyError, notifySuccess, notifyWarning, PERIOD_OPTIONS, previousCompetenceKey, recentCompetenceKeys } from "@/components/rma/rma.util";

function shiftKey(key, months) {
    const [year, month] = key.split("-").map(Number);
    const date = new Date(Date.UTC(year, month - 1 + months, 1));
    return `${date.getUTCFullYear()}-${String(date.getUTCMonth() + 1).padStart(2, "0")}`;
}

const SHORT_MONTHS = ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"];

// Periodo de N meses a partir de `key`: "jul a set/2026" (mensal: "julho/2026").
function periodLabel(key, months = 1) {
    if (!(months > 1)) return competenceLabel(key);
    const end = shiftKey(key, months - 1);
    const startMonth = SHORT_MONTHS[Number(key.slice(5, 7)) - 1];
    const endMonth = SHORT_MONTHS[Number(end.slice(5, 7)) - 1];
    return key.slice(0, 4) === end.slice(0, 4) ? `${startMonth} a ${endMonth}/${end.slice(0, 4)}` : `${startMonth}/${key.slice(0, 4)} a ${endMonth}/${end.slice(0, 4)}`;
}

function monthsBetween(a, b) {
    const [ya, ma] = a.split("-").map(Number);
    const [yb, mb] = b.split("-").map(Number);
    return (yb - ya) * 12 + (mb - ma);
}

// Prazo: dia do mes seguinte ao fim do periodo (dia inexistente = ultimo dia), como no backend.
function dueDateOf(key, dueDay, months = 1) {
    const next = shiftKey(key, months);
    const [year, month] = next.split("-").map(Number);
    const lastDay = new Date(Date.UTC(year, month, 0)).getUTCDate();
    const day = Math.min(Math.max(Number(dueDay) || 1, 1), lastDay);
    return `${next}-${String(day).padStart(2, "0")}`;
}

// Configuracao do RMA do caso (aba Configuracao).
export default {
    name: "RmaSettingsForm",

    props: {
        clientId: { type: Number, required: true },
        competences: { type: Array, default: () => [] },
        // Area: "accounting" (RMA) ou "legal" (Juridico).
        track: { type: String, default: "accounting" },
    },

    data: () => ({
        loaded: false,
        saving: false,
        savedActive: false,
        companies: [],
        documentTypes: [],
        representatives: [],
        admins: [],
        accountingSpecialist: null,
        suggestedResponsible: null,
        suggestionApplied: false,
        openCompanyPanels: [0],
        modeItems: [
            { value: "default", text: "Padrão para todas as empresas" },
            { value: "by_company", text: "Por CNPJ" },
        ],
        periodOptions: PERIOD_OPTIONS,
        form: { rural_producer: false, documents_mode: "default", company_type_ids: {}, responsible_admin_id: null, review_before_send: false, active: false, start_competence: null, due_day: 20, reminder_days_before: 5, overdue_interval_days: 5, type_ids: [], company_ids: [], cc_emails: "", period_months: 1, client_admin_id: null },
        invite: { name: "", email: "", saving: false },
        open: { competences: [previousCompetenceKey()], sendRequest: true, saving: false },
    }),

    computed: {
        isLegal() {
            return this.track === "legal";
        },
        // Representantes ativos (inativos nao recebem e-mail).
        clientResponsibleOptions() {
            return this.representatives.filter((person) => person.active || person.id === this.form.client_admin_id)
                .map((person) => ({ id: person.id, label: `${person.name} · ${person.email}${person.active ? "" : " (inativo)"}` }));
        },
        // Aviso sobre o especialista da contabilidade (sugestao de responsavel).
        responsibleHint() {
            if (!this.accountingSpecialist) return null;
            if (this.suggestionApplied && this.suggestedResponsible && this.form.responsible_admin_id === this.suggestedResponsible.id) {
                return { tone: "info", text: `Sugerido: ${this.accountingSpecialist.name}, especialista da contabilidade do caso. Salve a configuração para confirmar.` };
            }
            if (!this.suggestedResponsible) {
                return { tone: "warn", text: `O especialista da contabilidade (${this.accountingSpecialist.name}) não tem usuário no backoffice com o mesmo e-mail; escolha o responsável manualmente.` };
            }
            return null;
        },
        enabledCompanies() {
            return this.companies.filter((company) => this.form.company_ids.includes(company.id));
        },
        documentsDescription() {
            if (this.form.documents_mode === "by_company") {
                return `Documentos escolhidos por CNPJ (${this.enabledCompanies.length} empresa(s)). O catálogo fica em Fiscalização mensal › Tipos de documentos${this.isLegal ? " (aba Jurídico)" : ""}.`;
            }
            return `${this.form.type_ids.length} de ${this.documentTypes.length} tipos do catálogo. O catálogo fica em Fiscalização mensal › Tipos de documentos${this.isLegal ? " (aba Jurídico)" : ""}.`;
        },
        startItems() {
            const current = shiftKey(previousCompetenceKey(), 1);
            return [shiftKey(current, 1), current, ...recentCompetenceKeys(24)].map((key) => ({ value: key, text: competenceLabel(key) }));
        },
        // Periodicidade maior que mensal: so os periodos alinhados ao 1o periodo salvo.
        openItems() {
            const opened = new Set(this.competences.map((item) => item.key));
            const months = Number(this.form.period_months) || 1;
            const start = this.form.start_competence;
            return recentCompetenceKeys(24)
                .filter((key) => !opened.has(key))
                .filter((key) => months === 1 || !start || (monthsBetween(start, key) >= 0 && monthsBetween(start, key) % months === 0))
                .map((key) => ({ value: key, text: periodLabel(key, months) }));
        },
        startHint() {
            const months = Number(this.form.period_months) || 1;
            if (!this.form.start_competence) return months > 1 ? "Primeiro mês do primeiro período cobrado." : "Primeiro mês cobrado. A solicitação sai no dia 1 do mês seguinte.";
            const requestMonth = shiftKey(this.form.start_competence, months);
            return `A solicitação de ${periodLabel(this.form.start_competence, months)} sai em 01/${requestMonth.slice(5, 7)}/${requestMonth.slice(0, 4)} (ou na próxima execução, se essa data já passou).`;
        },
        exampleLabel() {
            const months = Number(this.form.period_months) || 1;
            return months > 1 ? `período ${periodLabel("2026-06", months)}` : "competência de junho";
        },
        exampleRequest() {
            const month = shiftKey("2026-06", Number(this.form.period_months) || 1);
            return `01/${month.slice(5, 7)}`;
        },
        exampleDue() {
            return formatDate(dueDateOf("2026-06", this.form.due_day, Number(this.form.period_months) || 1));
        },
        exampleReminder() {
            const due = new Date(`${dueDateOf("2026-06", this.form.due_day, Number(this.form.period_months) || 1)}T12:00:00Z`);
            due.setUTCDate(due.getUTCDate() - (Number(this.form.reminder_days_before) || 0));
            return Number(this.form.reminder_days_before) ? formatDate(due.toISOString()) : "(sem lembrete)";
        },
        canInvite() {
            return this.invite.name.trim().length > 1 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.invite.email.trim());
        },
    },

    watch: {
        competences() {
            const available = new Set(this.openItems.map((item) => item.value));
            this.open.competences = this.open.competences.filter((key) => available.has(key));
            if (!this.open.competences.length && this.openItems.length) this.open.competences = [this.openItems[0].value];
        },
    },

    created() {
        this.load();
    },

    methods: {
        formatExtensions,
        formatDateTime,

        adminText(admin) {
            return `${admin.name} · ${admin.email}`;
        },

        async load() {
            try {
                const result = await axios.get(`/api/admin/rma/clients/${this.clientId}/settings`, { params: { track: this.track } });
                this.apply(result.data.content);
            } catch (error) {
                notifyError(this, error);
            }
        },

        apply(content) {
            const settings = content.settings;
            this.companies = content.companies;
            this.documentTypes = content.document_types;
            this.representatives = content.representatives;
            this.admins = content.admins || [];
            this.accountingSpecialist = content.accounting_specialist || null;
            this.suggestedResponsible = content.suggested_responsible || null;
            this.savedActive = settings.active;
            const available = new Set(this.openItems.map((item) => item.value));
            this.open.competences = this.open.competences.filter((key) => available.has(key));
            if (!this.open.competences.length && this.openItems.length) this.open.competences = [this.openItems[0].value];
            this.form = {
                active: settings.active,
                start_competence: settings.start_competence ? settings.start_competence.slice(0, 7) : previousCompetenceKey(),
                due_day: settings.due_day,
                reminder_days_before: settings.reminder_days_before,
                overdue_interval_days: settings.overdue_interval_days,
                type_ids: content.document_types.filter((type) => type.selected).map((type) => type.id),
                company_ids: content.companies.filter((company) => company.rma_enabled).map((company) => company.id),
                cc_emails: settings.cc_emails || "",
                // Sem responsavel salvo: sugere o usuario do especialista da contabilidade do caso.
                responsible_admin_id: settings.responsible_admin_id || (this.suggestedResponsible ? this.suggestedResponsible.id : null),
                review_before_send: !!settings.review_before_send,
                period_months: Number(settings.period_months) || 1,
                client_admin_id: settings.client_admin_id || null,
                documents_mode: settings.documents_mode === "by_company" ? "by_company" : "default",
                rural_producer: !!(content.client && content.client.rural_producer),
                company_type_ids: content.companies.reduce((map, company) => ({ ...map, [company.id]: [...(company.type_ids || [])] }), {}),
            };
            this.suggestionApplied = !settings.responsible_admin_id && !!this.suggestedResponsible;
            this.loaded = true;
        },

        toggleCompanyTypes(companyId) {
            const current = this.form.company_type_ids[companyId] || [];
            this.$set(this.form.company_type_ids, companyId, current.length === this.documentTypes.length ? [] : this.documentTypes.map((type) => type.id));
        },

        copyDefaultTypes(companyId) {
            this.$set(this.form.company_type_ids, companyId, [...this.form.type_ids]);
        },

        toggleAllTypes() {
            this.form.type_ids = this.form.type_ids.length === this.documentTypes.length ? [] : this.documentTypes.map((type) => type.id);
        },

        async save() {
            this.saving = true;
            try {
                const result = await axios.put(`/api/admin/rma/clients/${this.clientId}/settings`, { ...this.form, track: this.track }, { params: { track: this.track } });
                this.apply(result.data.content);
                notifySuccess(this, "Configuração salva.");
                this.$emit("saved", result.data.content);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.saving = false;
            }
        },

        async sendInvite() {
            this.invite.saving = true;
            try {
                await axios.post("/api/admin/client-admins", { name: this.invite.name.trim(), email: this.invite.email.trim(), client_ids: [this.clientId] });
                notifySuccess(this, "Convite enviado com a senha provisória.");
                this.invite = { name: "", email: "", saving: false };
                await this.load();
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.invite.saving = false;
            }
        },

        async openCompetence() {
            this.open.saving = true;
            try {
                const result = await axios.post(`/api/admin/rma/clients/${this.clientId}/competences`, {
                    competences: [...this.open.competences].sort(),
                    send_request: this.open.sendRequest,
                    track: this.track,
                });
                const opened = result.data.content.competences || [];
                const labels = opened.map((row) => row.label).join(", ");
                const email = result.data.content.email;
                if (this.open.sendRequest && email && email.no_recipients) notifyWarning(this, `Aberta(s): ${labels}. Não há usuário da recuperanda para receber a solicitação.`);
                else if (this.open.sendRequest && email && !email.sent) notifyWarning(this, `Aberta(s): ${labels}. A solicitação não foi entregue; veja no Histórico.`);
                else notifySuccess(this, opened.length > 1 ? `Competências abertas: ${labels}.` : `Competência ${labels} aberta.`);
                this.open.competences = [];
                this.$emit("opened", opened[opened.length - 1]);
            } catch (error) {
                notifyError(this, error);
            } finally {
                this.open.saving = false;
            }
        },

        // Atalho do botao "Abrir competencia" do cabecalho do caso.
        focusOpen() {
            if (this.$refs.openSection) this.$refs.openSection.scrollIntoView({ behavior: "smooth", block: "center" });
        },
    },
};
</script>

<style scoped>
.rma-docs-companies {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    overflow: hidden;
}

.rma-docs-company + .rma-docs-company {
    border-top: 1px solid #eef2f6;
}

.rma-docs-company__header {
    min-height: 56px !important;
    padding: 10px 16px !important;
}

.rma-docs-company ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 16px 12px;
}
</style>
